import { ThemeComponent } from "@/theme/ThemeComponent";
import { OptionSelector } from "@/utils/OptionSelectors";
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import { ProductOption } from "./ProductOptionPicker";
import { FakeDropdown } from '@/components/FakeDropdown/FakeDropdown';
import { log } from "console";

@Component
export class ProductDropdownOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop values!: string[];
    @Prop selected!: string|null;
    @Prop position!: number;

    @Ref input!: HTMLSelectElement;
    @Ref fakeDropdown!: FakeDropdown;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string|null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        const input =this.querySelector('.fake-dropdown__input') as HTMLInputElement;
        const inputValue: string = input?.value;

        this.$subscribe(this.fakeDropdown.onChange, (value) => {
            this.valueChanged(value);
        });
        this.valueChanged(inputValue);
    }

    private valueChanged(value:string) {
        this.selected = value || null;
        this._onChange.dispatch(this.selected);
    }

    public select(value: string|null) {
        const input = this.querySelector('.fake-dropdown__input') as HTMLInputElement;
        this.selected = input?.value;
        this.input.value = value || '';
    }

    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);

        this.updateOptionLabels();
    }

    private updateOptionLabels() {
        const values_array = this.fakeDropdown.querySelectorAll('[data-ref="option"]');
        for (const optionEl of values_array) {
            const option_text = optionEl.textContent?.trim().toLowerCase() as string;
            if (this.valuesWithoutStock.indexOf(option_text) > -1) {
                optionEl.innerHTML += ' - Out of stock';
            } else if (this.valuesWithoutVariant.indexOf(option_text) > -1) {
                optionEl.innerHTML += ' - Not available';
            }
        }
    }
}
